<template>
  <div class="assets">
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang345') }}</span>
    </div>
    <div class="pd">
      <div class="list">
        <div class="box">
          <div class="box_item">
            <span class="left">{{ $t('lang370') }}</span>
            <div class="f">
              <img src="@/assets/images/index/teac.png" alt="" class="icon" />
              <van-field v-model="stock" placeholder="0" class="input" type="number" />
            </div>
          </div>
          <div class="box_item">
            <span class="left">{{ $t('lang414') }}</span>
            <div class="f">
              <img src="@/assets/images/index/chabao.png" alt="" class="icon" />
              <van-field v-model="price" placeholder="0" class="input" type="number" />
            </div>
          </div>
        </div>
      </div>
      <div class="yuji_box">
        <div class="title">{{ $t('lang364') }}</div>

        <div class="f">
          {{ $t('lang363') }}
          <span class="grey f">
            ({{ $t('lang362') + '：' }}

            <svg width="12" height="22" viewBox="32 0 50 96" xmlns="http://www.w3.org/2000/svg">
              <path d="M70,35 C56,28 38,40 40,54 C40,64 50,74 70,66" fill="none" stroke="#808080" stroke-width="6" stroke-linecap="round" />
              <line x1="52" y1="29" x2="52" y2="73" stroke="#808080" stroke-width="5.2" stroke-linecap="round" />
              <line x1="63" y1="29" x2="63" y2="73" stroke="#808080" stroke-width="5.2" stroke-linecap="round" />
            </svg>
            {{ balance }})</span
          >
        </div>
      </div>
      <div class="buy" @click="submit">
        <van-button class="buy_btn" type="primary">{{ $t('lang415') }}</van-button>
      </div>
      <div class="tips">
        <div class="tips_tit">{{ $t('lang416') }}</div>
        <div v-html="configInfo.buy_desc"></div>
      </div>
    </div>
    <van-overlay :show="loading">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" class="loading" />
      </div>
    </van-overlay>
  </div>
</template>
  
  <script>
import { homeApi } from '@/api/index';
import { dateFormat } from '@/utils/formatTool.js';
import { Dialog, Notify, Toast } from 'vant';
export default {
  data() {
    return {
      page: 0,
      stock: '',
      price: '',
      configInfo: {
        buy_min_price: 0,
        buy_min_num: 0,
        buy_serve_fee: 0,
        buy_desc: '',
      },
      loading: false,
      balance: 0,
    };
  },
  mounted() {
    this.getTeacConfig();
    this.getUserInfo();
  },
  methods: {
    //返回上一页
    back() {
      this.$router.back();
    },
    navigation(name) {
      this.$router.push({ name });
    },
    changeNav(item, index) {
      this.navIndex = index;
    },
    dateFormatFn(date) {
      return dateFormat(new Date(date * 1000), 'yyyy-MM-dd hh:mm:ss');
    },
    getUserInfo() {
      homeApi.getUserInfo({}).then(res => {
        if (res.code == 200) {
          this.balance = res.data.balance;
        } else {
        }
      });
    },
    getTeacConfig() {
      homeApi.getTeacConfig({}).then(res => {
        if (res.code == 200) {
          this.configInfo = res.data;
        } else {
        }
      });
    },
    submit() {
      let _this = this;
      if (!this.stock) {
        return this.$toast(this.$t('lang420'));
      }
      if (!this.price) {
        return this.$toast(this.$t('lang421'));
      }
      let params = {
        stock: this.stock,
        price: this.price,
      };
      Dialog.confirm({
        title: _this.$t('lang136'),
        message: _this.$t('lang419'),
        confirmButtonText: _this.$t('lang111'),
        cancelButtonText: _this.$t('lang135'),
      })
        .then(() => {
          _this.loading = true;
          homeApi.setTeacBuying(params).then(res => {
            if (res.code == 200) {
              _this.loading = false;
              Toast({ message: _this.$t('lang427') });
              _this.$router.back();
            } else if (res.code == 15001) {
              _this.loading = false;
              // setTimeout(() => {
              //   _this.$router.push('recharge');
              // }, 300);
            } else {
              _this.loading = false;
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
  
  <style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 15px 0;
  // z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-sa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  flex-direction: column;
}
.f {
  display: flex;
  align-items: center;
}
.assets {
  min-height: 100vh;
  padding: 50px 0 0;
  background-color: #fff;
  .top {
    color: #000;
    padding-bottom: 16px;
    margin: 0 6px;
  }
  .pd {
    padding: 4px;
    //   margin-top: 4px;
    // background-color: #fff;
  }

  .bare {
    text-align: center;
    font-size: 14px;
    padding: 60px 14px;
    color: #888;
  }
  .list {
    border-radius: 20px;
    padding: 0 14px;
    background-color: #fff;
    // margin: 16px 6px;

    .box {
      width: 100%;
      color: #000;
      font-size: 14px;
      //   padding: 18px 0 18px;

      &_item {
        display: flex;
        flex-direction: column;
        // align-items: center;
        // justify-content: space-between;
        padding: 16px 0 2px;
        border-bottom: 0.5px solid rgba(190, 190, 190, 0.2);

        .left {
          font-size: 13px;
          padding-bottom: 10px;
        }
        .mobile {
          font-size: 14px;
          color: #000;
          font-weight: 550;
        }
        .input {
          width: 180px;
          font-size: 29px;
          font-weight: 700;
          margin-left: 6px;
        }

        .icon {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
  .buy {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0 16px;
    &_btn {
      width: 80%;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      white-space: nowrap;
      letter-spacing: 1px;
      padding: 0 10px;
      border: none;
      border-radius: 30px;
      background-color: #29b286;
    }
  }
  .tips {
    color: #888888;
    font-size: 12px;
    line-height: 180%;
    padding: 14px;

    &_tit {
      color: #000;
    }
  }

  .yuji_box {
    font-size: 12px;
    color: #000;
    letter-spacing: 1px;
    padding: 14px;
    border-radius: 12px;
    margin-bottom: 10px;
    border-bottom: 0.5px solid rgba(190, 190, 190, 0.2);
    .pic {
      width: 80px;
      height: 80px;
      border-radius: 8px;
    }

    .right {
      padding-left: 14px;
      .name_box {
        color: #808080;
        font-size: 13px;

        .name {
          color: #000;
          font-size: 16px;
          font-weight: 600;
          line-height: 160%;
        }
      }
      .qiu {
        padding-top: 8px;
        &_price {
          font-size: 17px;
          font-weight: 600;
          margin-left: -2px;
          margin-top: -3px;
        }
      }
    }
    .title {
      font-size: 13px;
      font-weight: 600;
      line-height: 160%;
      padding-bottom: 8px;
    }
    .price {
      font-size: 13px;
      font-weight: 600;
      margin-left: -2px;
    }
    .green {
      color: #29b286;
    }
    .grey {
      color: #808080;
    }
    .van-checkbox {
      padding-top: 6px;
    }
    .desc {
      font-size: 11px;
      line-height: 150%;
      padding-top: 3px;
    }
    .yuji {
      width: 100%;
      // padding-top: 8px;
    }
    .font {
      color: #808080;
      font-size: 11px;
    }
    .snlist {
      flex-wrap: wrap;
      // justify-content: space-around;
      justify-content: flex-start;
      gap: 10px; /* 横向和纵向间距 */
      padding-top: 8px;
      &_item {
        font-size: 11px;
        text-align: center;
        padding: 4px 6px;
        border-radius: 4px;
        // margin: 0 10px 10px 0;
        width: calc((100% - 20px) / 3); /* 3列，减去两个gap */
        background-color: #f5f5f5;
      }
      .snlist_item_active {
        position: relative;
        color: #29b286;
        background-color: #cfe9e0;
        svg {
          position: absolute;
          bottom: -6px;
          right: -7px;
          font-size: 1px;
          width: 8px;
          z-index: 100;
          fill: #fff;
        }
      }
      .snlist_item_active_tag {
        bottom: 0px;
        right: 0px;
        width: 0;
        height: 0;
        z-index: 9;
        position: absolute;
        border-width: 8px 8px;
        border-color: rgba(0, 0, 0, 0) #29b286 #29b286 rgba(0, 0, 0, 0);
        border-style: solid;
        border-radius: 4px;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
    }
    .reflash {
      font-size: 10px;
      color: #000;
      width: calc(100vw - 150px);
      padding: 8px;
      border-radius: 6px;
      margin-top: 8px;
      background-color: #f5f5f5;

      &_price {
        font-size: 16px;
        font-weight: 600;
        margin-left: -6px;
      }
    }
    .pt {
      padding-top: 10px;
    }
    /deep/ .van-checkbox__icon .van-icon {
      border-radius: 2px;
      border-color: #29b286 !important;
    }
    /deep/.van-stepper__input {
      background-color: #fff;
    }
    /deep/.van-stepper__plus,
    /deep/.van-stepper__minus {
      transform: scale(0.9);
      border-radius: 50%;
    }
    /deep/.van-field {
      font-size: 18px;
      font-weight: 600;
      margin-left: -10px;
    }
    /deep/.van-field__control::placeholder {
      font-size: 15px;
      font-weight: normal;
    }
    /deep/.van-field__control::-webkit-input-placeholder {
      font-size: 15px;
      font-weight: normal;
    }
    /deep/.van-field__control::-moz-placeholder {
      font-size: 15px;
      font-weight: normal;
    }
    /deep/.van-field__control::-ms-input-placeholder {
      font-size: 15px;
      font-weight: normal;
    }
  }
}
.wrapper {
  // display: flex;
  // justify-content: center;
  .loading {
    position: absolute;
    left: 46%;
    top: 46%;
  }
}
</style>